// @ts-nocheck
import { httpClient } from '../../../core/network';

class PromotionService {
  static fetchPromotions(
    page = 1,
    size = 20,
    { onlyActive = true, withActivePeriods = false } = {},
    { orderBy = 'created', sortOrder = 'desc' } = {}
  ) {
    const apiUrl = '/promotions';
    return httpClient.get(apiUrl, {
      params: {
        onlyactive: onlyActive,
        withactiveperiods: withActivePeriods,
        sortBy: orderBy,
        sortOrder: sortOrder,
        page,
        size,
      },
    });
  }

  static fetchPromotion(promotionId) {
    const apiUrl = `/promotions/${promotionId}`;
    return httpClient.get(apiUrl);
  }

  static createPromotion(promotionData) {
    const apiUrl = '/promotions';
    return httpClient.post(apiUrl, promotionData, {
      headers: { client: 'commercial' },
    });
  }

  static updatePromotion(promotionId, promotionData) {
    const apiUrl = `/promotions/${promotionId}`;
    return httpClient.put(apiUrl, promotionData, {
      headers: { client: 'commercial' },
    });
  }

  static deletePromotion(promotionId) {
    const apiUrl = `/promotions/${promotionId}`;
    return httpClient.delete(apiUrl);
  }

  static createPromotionPeriod(promotionId, periodsData) {
    const apiUrl = `/promotions/${promotionId}/period`;
    return httpClient.post(apiUrl, periodsData, {
      headers: { client: 'commercial' },
    });
  }
}

export default PromotionService;
